import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import PrivateRoute from './utils/PrivateRoute'
import WelcomePage from './pages/Welcome';
import LoginPage from "./pages/LoginPage";
import ForgotPassword from './pages/password/ForgotPassword';
import ResetPassword from './pages/password/ResetPassword';
import PasswordResetSuccess from './pages/password/PasswordResetSuccess';
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardHome from './pages/dashboard/components/DashboardHome';
import RiskManagement from './pages/dashboard/components/ManageRistsk';
// 
import ManageCartographs from './pages/dashboard/components/ManageCartographs';
import AddCartograph from './pages/dashboard/components/cartographie/AddCartograph';
import EditCartographie from './pages/dashboard/components/cartographie/EditCartographie';
import CartographDetails from './pages/dashboard/components/cartographie/CartographDetails';
import ViewCartographs from './pages/dashboard/components/cartographie/ViewCartographs';
import AllOrganizationCarto from './pages/dashboard/components/cartographie/AllOrganizationCarto';
// 
import ManageUsers from './pages/dashboard/components/ManageUsers';
import ManageUserRoles from './pages/dashboard/components/ManageRoles';

// 
import AddRisk from './pages/dashboard/components/risks/AddRisk';
import EditRisk from './pages/dashboard/components/risks/EditRisk';

// 
import ManageActivities from './pages/dashboard/components/ManageActivities';
import AddActivity from './pages/dashboard/components/activities/AddActivity';
import EditActivity from './pages/dashboard/components/activities/EditActivity';
import AddUser from './pages/dashboard/components/users/AddUser';
import EditUser from './pages/dashboard/components/users/EditUser';
import UserDetails from './pages/dashboard/components/users/UserDetails';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AllOrganisationRisks from './pages/dashboard/components/risks/ViewAllRisks';
import RiskDetails from './pages/dashboard/components/risks/RiskDetails';
import AllActivities from './pages/dashboard/components/activities/ViewAllActivities';
import ActivityDetails from './pages/dashboard/components/activities/ActivityDetails';


import RiskLogs from './pages/dashboard/components/admin/logs/RiskLogs';
import ProcessLogs from './pages/dashboard/components/admin/logs/ProcessLogs';
import UserLogs from './pages/dashboard/components/admin/logs/UserLogs';

// Detailed Logs 
import RiskDetailedLog from './pages/dashboard/components/admin/detailedLogs/RiskDetailedLog';
import ActivityDetailedLog from './pages/dashboard/components/admin/detailedLogs/ActivityDetailedLog';
import ProcessDetailedLog from './pages/dashboard/components/admin/detailedLogs/ProcessDetailedLog';
import ProcessTaskDetailedLog from './pages/dashboard/components/admin/detailedLogs/ProcessTaskDetailedLog';
import UserDetailedLogs from './pages/dashboard/components/admin/detailedLogs/UserDetailedLogs';
// 
import MyAssignedTasks from './pages/dashboard/components/tasks/MyAssignedTasks';
import AllOrganisationTask from './pages/dashboard/components/tasks/AllOrganisationTask';
import TaskDetails from './pages/dashboard/components/tasks/TaskDetails';
import RiskLogsDetailed from './pages/dashboard/components/admin/logs/RiskLogsDetailed';
import UserLogsDetailed from './pages/dashboard/components/admin/logs/UserLogsDetailed';
import ProcessLogsDetailes from './pages/dashboard/components/admin/logs/ProcessLogsDetailes';
import ActivityLogs from './pages/dashboard/components/admin/logs/ActivityLogs';
import ActivityLogsDetailes from './pages/dashboard/components/admin/logs/ActivityLogsDetailes';
import ProcessTaskLogs from './pages/dashboard/components/admin/logs/ProcessTaskLogs';
import ProcessTaskLogsDetails from './pages/dashboard/components/admin/logs/ProcessTaskLogsDetails';
import RegisterPage from './pages/RegisterPage';
import RoleBasedRoute from './utils/RoleBasedRoute';
import LoginSuperAdmin from './pages/LoginSuperAdmin';
import DashboardSuperAdmin from './pages/admin_dashboard/DashboardSuperAdmin';
import DashboardSuperAdminHome from './pages/admin_dashboard/pages/DashboardSuperAdminHome';
import Organizations from './pages/admin_dashboard/pages/Organizations';
import AddOrganisation from './pages/admin_dashboard/pages/organisation/AddOrganisation';
import OrganisationDetails from './pages/admin_dashboard/pages/organisation/OrganisationDetails';
import AllUsers from './pages/admin_dashboard/pages/AllUsers';
import AllUserDetails from './pages/admin_dashboard/pages/users/UserDetails';
import AllProcesses from './pages/admin_dashboard/pages/AllProcesses';
import AllProcessesDetails from './pages/admin_dashboard/pages/processes/AllProcessesDetails';
import AllRisks from './pages/admin_dashboard/pages/AllRisks';
import AllRisksDetails from './pages/admin_dashboard/pages/risks/AllRisksDetails';
import AllActivitiesA from './pages/admin_dashboard/pages/AllActivities';
import AllActivitiesDetails from './pages/admin_dashboard/pages/activities/AllActivitiesDetails';
import UpdateOrganization from './pages/admin_dashboard/pages/organisation/UpdateOrganization';
import OrganizationSubscriptions from './pages/admin_dashboard/pages/OrganizationSubscriptions';
import AddSubscription from './pages/admin_dashboard/pages/subscriptions/AddSubscription';
import SubscriptionDetails from './pages/admin_dashboard/pages/subscriptions/SubscriptionDetails';
import UpdateSubscription from './pages/admin_dashboard/pages/subscriptions/UpdateSubscription';
import SubscriptionHistory from './pages/admin_dashboard/pages/subscriptions/SubscriptionHistory';
import CompanyInfo from './pages/dashboard/components/CompanyInfo';
import NotFound from './pages/NotFound';
import AllAccountRequests from './pages/admin_dashboard/pages/AccountCreationRequests';
import AccountRequestDetail from './pages/admin_dashboard/pages/accountCreationRequests/AccountCreationReqeustDetailsl';

// Super Admin Audit Imports
import AllAuditProgramsList from './pages/admin_dashboard/pages/audits/auditPrograms/AllAuditProgramsList';
import AllAuditProgramDetails from './pages/admin_dashboard/pages/audits/auditPrograms/AllAuditProgramDetails';
import AllAuditProgramsHistory from './pages/admin_dashboard/pages/audits/auditPrograms/AllAuditProgramsHistory';
import AuditProgramHistory from './pages/admin_dashboard/pages/audits/auditPrograms/AuditProgramHistory';
import AllAuditPlansList from './pages/admin_dashboard/pages/audits/auditPlans/AllAuditPlansList';
import AllAuditPlanDetails from './pages/admin_dashboard/pages/audits/auditPlans/AllAuditPlanDetails';
import AllAuditPlansHistory from './pages/admin_dashboard/pages/audits/auditPlans/AllAuditPlansHistory';
import AuditPlanHistory from './pages/admin_dashboard/pages/audits/auditPlans/AuditPlanHistory';
import AllAuditSectionsList from './pages/admin_dashboard/pages/audits/auditSections/AllAuditSectionsList';
import AllAuditSectionDetails from './pages/admin_dashboard/pages/audits/auditSections/AllAuditSectionDetails';
import AllAuditSectionsHistory from './pages/admin_dashboard/pages/audits/auditSections/AllAuditSectionsHistory';
import AuditSectionHistory from './pages/admin_dashboard/pages/audits/auditSections/AuditSectionHistory';
import AllAuditQuestionsList from './pages/admin_dashboard/pages/audits/questions/AllAuditQuestionsList';
import AllAuditQuestionDetails from './pages/admin_dashboard/pages/audits/questions/AllAuditQuestionDetails';
import AllAuditQuestionsHistory from './pages/admin_dashboard/pages/audits/questions/AllAuditQuestionsHistory';
import AuditQuestionHistory from './pages/admin_dashboard/pages/audits/questions/AuditQuestionHistory';
import AllRecommendationActionsList from './pages/admin_dashboard/pages/audits/recommendations/AllRecommendationActionsList';
import AllRecommendationActionsHistory from './pages/admin_dashboard/pages/audits/recommendations/AllRecommendationActionsHistory';
import RecommendationActionHistory from './pages/admin_dashboard/pages/audits/recommendations/RecommendationActionHistory';
import AllRecommendationActionsDetails from './pages/admin_dashboard/pages/audits/recommendations/AllRecommendationActionsDetails';

// ------------------Audit Imports---------------------------------------------

import AuditProgramsList from './pages/dashboard/components/audits/auditManager/auditProgram/AuditProgramsList';
import AuditProgramDetails from './pages/dashboard/components/audits/auditManager/auditProgram/AuditProgramDetails';
import AuditProgramCreate from './pages/dashboard/components/audits/auditManager/auditProgram/AuditProgramCreate';
import AuditProgramEdit from './pages/dashboard/components/audits/auditManager/auditProgram/AuditProgramEdit';

import AuditPlansList from './pages/dashboard/components/audits/auditManager/auditPlan/AuditPlansList';
import AuditPlanDetails from './pages/dashboard/components/audits/auditManager/auditPlan/AuditPlanDetails';
import AuditPlanCreate from './pages/dashboard/components/audits/auditManager/auditPlan/AuditPlanCreate';
import AuditPlanEdit from './pages/dashboard/components/audits/auditManager/auditPlan/AuditPlanEdit';

import MyAuditPlansList from './pages/dashboard/components/audits/auditor/auditPlans/MyAuditPlansList';
import MyAuditPlanDetails from './pages/dashboard/components/audits/auditor/auditPlans/MyAuditPlanDetails';

import AuditSectionsList from './pages/dashboard/components/audits/auditor/auditSections/AuditSectionsList';
import AuditSectionDetails from './pages/dashboard/components/audits/auditor/auditSections/AuditSectionDetails';
import AuditSectionCreate from './pages/dashboard/components/audits/auditor/auditSections/AuditSectionCreate';
import AuditSectionEdit from './pages/dashboard/components/audits/auditor/auditSections/AuditSectionEdit';

import AuditQuestionsList from './pages/dashboard/components/audits/auditor/auditQuestions/AuditQuestionsList';
import AuditQuestionDetails from './pages/dashboard/components/audits/auditor/auditQuestions/AuditQuestionDetails';
import AuditQuestionCreate from './pages/dashboard/components/audits/auditor/auditQuestions/AuditQuestionCreate';
import AuditQuestionEdit from './pages/dashboard/components/audits/auditor/auditQuestions/AuditQuestionEdit';

import RecommendationsList from './pages/dashboard/components/audits/auditor/recommendations/RecommendationsList';
import RecommendationDetails from './pages/dashboard/components/audits/auditor/recommendations/RecommendationDetails';
import RecommendationCreate from './pages/dashboard/components/audits/auditor/recommendations/RecommendationCreate';
import RecommendationEdit from './pages/dashboard/components/audits/auditor/recommendations/RecommendationEdit';

// My Recommendations
import MyRecommendationsList from './pages/dashboard/components/audits/my-recommendations/MyRecommendationsList';
import MyRecommendationDetails from './pages/dashboard/components/audits/my-recommendations/MyRecommendationDetails';

// Published Audit Plans
import PublishedAuditPlansList from './pages/dashboard/components/audits/published/PublishedAuditPlansList';
import PublishedAuditPlanDetails from './pages/dashboard/components/audits/published/PublishedAuditPlanDetails';

// Audit History
import AuditProgramHistoryList from './pages/dashboard/components/audits/auditHistory/auditProgram/AuditProgramHistoryList';
import AuditProgramHistoryDetails from './pages/dashboard/components/audits/auditHistory/auditProgram/AuditProgramHistoryDetails';
import AuditPlanHistoryList from './pages/dashboard/components/audits/auditHistory/auditPlan/AuditPlanHistoryList';
import AuditPlanHistoryDetails from './pages/dashboard/components/audits/auditHistory/auditPlan/AuditPlanHistoryDetails';
import AuditSectionHistoryList from './pages/dashboard/components/audits/auditHistory/auditSection/AuditSectionHistoryList';
import AuditSectionHistoryDetails from './pages/dashboard/components/audits/auditHistory/auditSection/AuditSectionHistoryDetails';
import AuditQuestionHistoryList from './pages/dashboard/components/audits/auditHistory/auditQuestion/AuditQuestionHistoryList';
import AuditQuestionHistoryDetails from './pages/dashboard/components/audits/auditHistory/auditQuestion/AuditQuestionHistoryDetails';
import RecommendationHistoryList from './pages/dashboard/components/audits/auditHistory/recommendation/RecommendationHistoryList';
import RecommendationHistoryDetails from './pages/dashboard/components/audits/auditHistory/recommendation/RecommendationHistoryDetails';
import FollowUpHistoryList from './pages/dashboard/components/audits/auditHistory/followup/FollowUpHistoryList';
import FollowUpHistoryDetails from './pages/dashboard/components/audits/auditHistory/followup/FollowUpHistoryDetails';

import ManageAuditUsers from './pages/dashboard/components/ManageAuditUsers';

// Admin Audit Views
import AdminAuditProgramsList from './pages/dashboard/components/admin/audits/auditPrograms/AdminAuditProgramsList';
import AdminAuditProgramDetails from './pages/dashboard/components/admin/audits/auditPrograms/AdminAuditProgramDetails';
import AdminAuditProgramHistory from './pages/dashboard/components/admin/audits/auditPrograms/AdminAuditProgramHistory';
import AdminAuditPlansList from './pages/dashboard/components/admin/audits/auditPlans/AdminAuditPlansList';
import AdminAuditPlanDetails from './pages/dashboard/components/admin/audits/auditPlans/AdminAuditPlanDetails';
import AdminAuditPlanHistory from './pages/dashboard/components/admin/audits/auditPlans/AdminAuditPlanHistory';
import AdminAuditSectionsList from './pages/dashboard/components/admin/audits/auditSections/AdminAuditSectionsList';
import AdminAuditSectionDetails from './pages/dashboard/components/admin/audits/auditSections/AdminAuditSectionDetails';
import AdminAuditSectionHistory from './pages/dashboard/components/admin/audits/auditSections/AdminAuditSectionHistory';
import AdminAuditQuestionsList from './pages/dashboard/components/admin/audits/auditQuestions/AdminAuditQuestionsList';
import AdminAuditQuestionDetails from './pages/dashboard/components/admin/audits/auditQuestions/AdminAuditQuestionDetails';
import AdminAuditQuestionHistory from './pages/dashboard/components/admin/audits/auditQuestions/AdminAuditQuestionHistory';
import AdminRecommendationActionsList from './pages/dashboard/components/admin/audits/recommendationActions/AdminRecommendationActionsList';
import AdminRecommendationActionDetails from './pages/dashboard/components/admin/audits/recommendationActions/AdminRecommendationActionDetails';
import AdminRecommendationActionHistory from './pages/dashboard/components/admin/audits/recommendationActions/AdminRecommendationActionHistory';

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<WelcomePage />} /> 
            <Route path="/login" element={<LoginPage />} /> 
            <Route path="/user/admin-super/login" element={<LoginSuperAdmin />} /> 
              {/* Password Reset Routes */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/password-reset-success" element={<PasswordResetSuccess />} />

            {/* <Route path="/register" element={<RegisterPage />} />  */}

            {/* Catch all for unknown urls */}
            <Route path="*" element={<NotFound />} />

            {/* Super Admin Dashboard */}
            <Route path="/admin-panel" 
              element={
                <PrivateRoute>
                   <RoleBasedRoute checkSuperAdmin={true} >
                    <DashboardSuperAdmin />
                  </RoleBasedRoute>
                </PrivateRoute>
              }
            >

              <Route index element={<DashboardSuperAdminHome /> } />
              <Route path='organizations' element={<Organizations /> } />
              <Route path='organizations/add' element={<AddOrganisation /> } />
              <Route path='organizations/:id' element={<OrganisationDetails /> } />
              <Route path='organizations/:id/update' element={<UpdateOrganization /> } />
              <Route path='organizations/:id/subscription-history' element={<SubscriptionHistory /> } />

              <Route path='creation-requests' element={<AllAccountRequests /> } />
              <Route path='creation-requests/:requestId' element={<AccountRequestDetail /> } />

              <Route path='subscriptions' element={<OrganizationSubscriptions /> } />
              <Route path='subscriptions/add' element={<AddSubscription /> } />
              <Route path='subscriptions/:id' element={<SubscriptionDetails /> } />
              <Route path='subscriptions/:id/update' element={<UpdateSubscription /> } />
              
              <Route path='users' element={<AllUsers /> } />
              <Route path='users/:id' element={<AllUserDetails /> } />

              <Route path='processes' element={<AllProcesses /> } />
              <Route path='processes/:id' element={<AllProcessesDetails /> } />

              <Route path='activities' element={<AllActivitiesA /> } />
              <Route path='activities/:id' element={<AllActivitiesDetails /> } />
              
              <Route path='risks' element={<AllRisks /> } />
              <Route path='risks/:id' element={<AllRisksDetails /> } />

              {/* Super Admin Audit Routes */}
              <Route path='audit-programs' element={<AllAuditProgramsList /> } />
              <Route path='audit-programs/history' element={<AllAuditProgramsHistory /> } />
              <Route path='audit-programs/:id' element={<AllAuditProgramDetails /> } />
              <Route path='audit-programs/:id/history' element={<AuditProgramHistory /> } />
              
              <Route path='audit-plans' element={<AllAuditPlansList /> } />
              <Route path='audit-plans/history' element={<AllAuditPlansHistory /> } />
              <Route path='audit-plans/:id' element={<AllAuditPlanDetails /> } />
              <Route path='audit-plans/:id/history' element={<AuditPlanHistory /> } />
              
              <Route path='audit-sections' element={<AllAuditSectionsList /> } />
              <Route path='audit-sections/history' element={<AllAuditSectionsHistory /> } />
              <Route path='audit-sections/:id' element={<AllAuditSectionDetails /> } />
              <Route path='audit-sections/:id/history' element={<AuditSectionHistory /> } />
              
              <Route path='audit-questions' element={<AllAuditQuestionsList /> } />
              <Route path='audit-questions/history' element={<AllAuditQuestionsHistory /> } />
              <Route path='audit-questions/:id' element={<AllAuditQuestionDetails /> } />
              <Route path='audit-questions/:id/history' element={<AuditQuestionHistory /> } />
              
              <Route path='recommendation-actions' element={<AllRecommendationActionsList /> } />
              <Route path='recommendation-actions/history' element={<AllRecommendationActionsHistory /> } />
              <Route path='recommendation-actions/:id' element={<AllRecommendationActionsDetails /> } />
              <Route path='recommendation-actions/:id/history' element={<RecommendationActionHistory /> } />



              
            </Route>

            {/* Dashboard Routes */}
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              {/* Nested Routes inside Dashboard */}
              <Route index element={<DashboardHome />} />
              
              <Route path="risks" element={
                <RoleBasedRoute 
                  requiredRoles={["RiskManager", "RiskIdentifier"]}>
                  <RiskManagement />
                </RoleBasedRoute>
              } />

              <Route path="risks-organisation-all" element={
                <RoleBasedRoute 
                  requiredRoles={["Admin","RiskManager"]}>
                  <AllOrganisationRisks />
                </RoleBasedRoute>
                } 
              />
              <Route path="risks/add" element={
                <RoleBasedRoute 
                  requiredRoles={["RiskManager","RiskIdentifier"]}>
                  <AddRisk />
                </RoleBasedRoute>
              } />
              <Route path="risks/edit/:id" element={
                <RoleBasedRoute 
                  requiredRoles={["RiskManager", "RiskIdentifier"]}>
                  <EditRisk />
                </RoleBasedRoute>
              } />
              <Route path="risks/:riskId" element={<RiskDetails />} />

              {/* Cartographies / processes */}
              <Route path="cartographies" element={
                <RoleBasedRoute 
                  requiredRoles="RiskManager">
                  <ManageCartographs />
                </RoleBasedRoute>
              } />
              
              <Route path="cartographies/all-cartographies" element={
                 <RoleBasedRoute 
                    requiredRoles={["Admin","RiskManager"]}>
                    <AllOrganizationCarto />
                  </RoleBasedRoute>
              } />

              <Route path="cartographies/add" element={
                  <RoleBasedRoute 
                    requiredRoles="RiskManager">
                    <AddCartograph />
                  </RoleBasedRoute>
              } />

              <Route path="cartographies/edit/:id" element={
                  <RoleBasedRoute 
                    requiredRoles="RiskManager">
                    <EditCartographie />
                  </RoleBasedRoute>
              } />

              <Route path="cartographies/view" element={<ViewCartographs />} />
              <Route path="cartographies/:id" element={<CartographDetails />} />

              {/* Activities */}
              <Route path="activities/all" element={
                <RoleBasedRoute 
                  requiredRoles={["Admin","RiskManager"]}>
                  <AllActivities />
                </RoleBasedRoute>
              } />
                <Route path="activities" element={
                    <RoleBasedRoute 
                      requiredRoles="RiskManager">
                      <ManageActivities />
                    </RoleBasedRoute>
                } />
                
                <Route path="activities/add" element={
                  <RoleBasedRoute 
                      requiredRoles="RiskManager">
                      <AddActivity />
                  </RoleBasedRoute>
                } />

                <Route path="activities/edit/:id" element={
                  <RoleBasedRoute 
                      requiredRoles="RiskManager">
                      <EditActivity />
                  </RoleBasedRoute>
                } />
              
              <Route path="activities/details/:activityId" element={<ActivityDetails />} />
{/* ----------------------------------------------------------------------------------------------------- */}
              {/* Audit Module Routes */}
              
              {/* Audit Programs */}
              <Route path="audit/programs" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditProgramsList />
                </RoleBasedRoute>
              } />
              <Route path="audit/programs/create" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditProgramCreate />
                </RoleBasedRoute>
              } />
              <Route path="audit/programs/:id" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Auditor', 'Admin']}>
                  <AuditProgramDetails />
                </RoleBasedRoute>
              } />
              <Route path="audit/programs/:id/edit" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditProgramEdit />
                </RoleBasedRoute>
              } />

              {/* Audit Plans */}
              <Route path="audit/plans" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditPlansList />
                </RoleBasedRoute>
              } />
              <Route path="audit/plans/create" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditPlanCreate />
                </RoleBasedRoute>
              } />
              <Route path="audit/plans/:id" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Auditor', 'Auditee', 'Admin']}>
                  <AuditPlanDetails />
                </RoleBasedRoute>
              } />
              <Route path="audit/plans/:id/edit" element={
                <RoleBasedRoute requiredRoles={['AuditManager', 'Admin']}>
                  <AuditPlanEdit />
                </RoleBasedRoute>
              } />

              {/* My Audit Plans (Auditor/Auditee View) */}
              <Route path="audit/my-plans" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <MyAuditPlansList />
                </RoleBasedRoute>
              } />
              <Route path="audit/my-plans/:id" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <MyAuditPlanDetails />
                </RoleBasedRoute>
              } />

              {/* Audit Sections (Auditor Management) - Nested under audit plans */}
              <Route path="audit/audit-plans/:auditPlanId/sections" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <AuditSectionsList />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/create" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <AuditSectionCreate />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:id" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <AuditSectionDetails />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:id/edit" element={
                <RoleBasedRoute requiredRoles={['AuditUser','AuditManager']}>
                  <AuditSectionEdit />
                </RoleBasedRoute>
              } />

              {/* Audit Questions (Auditor Management) - Nested under sections */}
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <AuditQuestionsList />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/create" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <AuditQuestionCreate />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <AuditQuestionDetails />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId/edit" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <AuditQuestionEdit />
                </RoleBasedRoute>
              } />

              {/* Audit Recommendations (Auditor Management) - Nested under questions */}
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId/recommendations" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <RecommendationsList />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId/recommendations/create" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <RecommendationCreate />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId/recommendations/:recommendationId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <RecommendationDetails />
                </RoleBasedRoute>
              } />
              <Route path="audit/audit-plans/:auditPlanId/sections/:sectionId/questions/:questionId/recommendations/:recommendationId/edit" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'Admin','AuditManager']}>
                  <RecommendationEdit />
                </RoleBasedRoute>
              } />

              {/* My Recommendations (User's Own Recommendations) */}
              <Route path="audit/my-recommendations" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager', 'Admin','RiskManager', "RiskIdentifier",'CartoViewer']}>
                  <MyRecommendationsList />
                </RoleBasedRoute>
              } />
              <Route path="audit/my-recommendations/:id" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager', 'Admin', 'RiskManager', "RiskIdentifier",'CartoViewer']}>
                  <MyRecommendationDetails />
                </RoleBasedRoute>
              } />

              {/* Published Audit Plans (For Audit Program Parties) */}
              <Route path="audit/published-plans" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager', 'Admin']}>
                  <PublishedAuditPlansList />
                </RoleBasedRoute>
              } />
              <Route path="audit/published-plans/:id" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager', 'Admin']}>
                  <PublishedAuditPlanDetails />
                </RoleBasedRoute>
              } />

              {/* ===============================Audit Activity History Routes ====================================== */}

              {/* Audit Program History (AuditManager only) */}
              <Route path="audit/history/programs" element={
                <RoleBasedRoute requiredRoles={['AuditManager']}>
                  <AuditProgramHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/programs/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditManager']}>
                  <AuditProgramHistoryDetails />
                </RoleBasedRoute>
              } />

              {/* Audit Plan History (Both AuditManager and AuditUser) */}
              <Route path="audit/history/plans" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditPlanHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/plans/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditPlanHistoryDetails />
                </RoleBasedRoute>
              } />

              {/* Audit Section History (Both AuditManager and AuditUser) */}
              <Route path="audit/history/sections" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditSectionHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/sections/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditSectionHistoryDetails />
                </RoleBasedRoute>
              } />

              {/* Audit Question History (Both AuditManager and AuditUser) */}
              <Route path="audit/history/questions" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditQuestionHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/questions/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <AuditQuestionHistoryDetails />
                </RoleBasedRoute>
              } />

              {/* Recommendation History (Both AuditManager and AuditUser) */}
              <Route path="audit/history/recommendations" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <RecommendationHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/recommendations/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <RecommendationHistoryDetails />
                </RoleBasedRoute>
              } />

              {/* Follow-Up History (Both AuditManager and AuditUser) */}
              <Route path="audit/history/followups" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <FollowUpHistoryList />
                </RoleBasedRoute>
              } />
              <Route path="audit/history/followups/:historyId" element={
                <RoleBasedRoute requiredRoles={['AuditUser', 'AuditManager']}>
                  <FollowUpHistoryDetails />
                </RoleBasedRoute>
              } />


              {/* =======Organization Admin routes for audits =============*/}

{/* ---------------------------------------------------------------------------------------------------- */}

              {/* tasks */}
              <Route path="tasks/my-tasks" element={<MyAssignedTasks />} />
              <Route path="tasks/all" element={<AllOrganisationTask />} />
              <Route path="tasks/:taskId" element={<TaskDetails />} />

              
            {/* ---------------------Admin Routes */}
            <Route path="admin" 
              element={
              <RoleBasedRoute  requiredRoles="Admin" >
                <div><Outlet /></div>
                </RoleBasedRoute>
              }>

                {/* users */}
                <Route path="users" element={<ManageUsers />} />
                <Route path="users/add" element={<AddUser />} />
                <Route path="users/edit/:id" element={<EditUser />} />
                <Route path="users/:id" element={<UserDetails />} />
                <Route path="user-roles" element={<ManageUserRoles />} />
                <Route path="audit-users" element={<ManageAuditUsers />} />
                <Route path="organization-infos" element={<CompanyInfo />} />
              
                <Route path="logs/processes" element={<ProcessLogs />} />
                <Route path="logs/processes/details/:id" element={<ProcessLogsDetailes />} />

                <Route path="logs/process-tasks" element={<ProcessTaskLogs />} />
                <Route path="logs/process-tasks/details/:id" element={<ProcessTaskLogsDetails />} />

                <Route path="logs/activities" element={<ActivityLogs />} />
                <Route path="logs/activities/details/:historyType/:id" element={<ActivityLogsDetailes />} />

                <Route path="logs/risks" element={<RiskLogs />} />
                <Route path="logs/risks/details/:id" element={<RiskLogsDetailed />} />

                <Route path="logs/users" element={<UserLogs />} />
                <Route path="logs/users/details/:id" element={<UserLogsDetailed />} />
                

                {/* Detailed Logs - Entity Evolution History */}
                <Route path="detailedLogs/risk/:riskId" element={<RiskDetailedLog />} />
                <Route path="detailedLogs/activity/:activityId" element={<ActivityDetailedLog />} />
                <Route path="detailedLogs/process/:processId" element={<ProcessDetailedLog />} />
                <Route path="detailedLogs/user/:userId" element={<UserDetailedLogs />} />
                <Route path="detailedLogs/process-task/:processTaskId" element={<ProcessTaskDetailedLog />} />

                {/* Admin Audit Views */}
                <Route path="audits/programs" element={<AdminAuditProgramsList />} />
                <Route path="audits/programs/:id" element={<AdminAuditProgramDetails />} />
                <Route path="audits/programs/:programId/history" element={<AdminAuditProgramHistory />} />
                <Route path="audits/plans" element={<AdminAuditPlansList />} />
                <Route path="audits/plans/:id" element={<AdminAuditPlanDetails />} />
                <Route path="audits/plans/:planId/history" element={<AdminAuditPlanHistory />} />
                <Route path="audits/plans/:planId/sections" element={<AdminAuditSectionsList />} />
                <Route path="audits/sections/:sectionId" element={<AdminAuditSectionDetails />} />
                <Route path="audits/sections/:sectionId/history" element={<AdminAuditSectionHistory />} />
                <Route path="audits/sections/:sectionId/questions" element={<AdminAuditQuestionsList />} />
                <Route path="audits/questions/:questionId" element={<AdminAuditQuestionDetails />} />
                <Route path="audits/questions/:questionId/history" element={<AdminAuditQuestionHistory />} />
                <Route path="audits/recommendation-actions" element={<AdminRecommendationActionsList />} />
                <Route path="audits/recommendation-actions/:actionId" element={<AdminRecommendationActionDetails />} />
                <Route path="audits/recommendation-actions/:actionId/history" element={<AdminRecommendationActionHistory />} />
              
            </Route>
          
            </Route>
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
